import React, { FC } from 'react';
import cls from 'classnames';

import LogIn from 'src/prize/scenes/LogIn';
import { INavItem } from 'src/prize/types/shoppe';

import { Link } from './atoms/Link';
import { Menu } from './molecules/Menu';

import styles from './index.module.sass';

interface LinksProps {
  className?: {
    container?: string;
    dropdownLink?: string;
    item?: string;
    link?: string;
  };
  data?: INavItem;
  desktopBreakpoint?: 'md' | 'lg';
}

const Links: FC<LinksProps> = ({ className, data, desktopBreakpoint = 'lg' }) => (
  <ul className={className?.container}>
    <li className={cls( className?.item, styles[`hide-${desktopBreakpoint}`])}>
      <LogIn className={className?.link} isMobile />
    </li>

    {data?.children?.map(( item ) => (
      <li className={cls( styles.item, className?.item )} key={item.id}>
        {item.children.length > 0 ? (
          <Menu
            className={{
              dropdownLink: className?.dropdownLink,
              item: className?.item,
              link: className?.link,
            }}
            data={item}
            desktopBreakpoint={desktopBreakpoint}
          />
        ) : (
          <Link className={className?.link} href={item.url}>
            {item.title}
          </Link>
        )}
      </li>
    ))}
  </ul>
);

export default Links;
